export default __webpack_public_path__ + "static/media/skippedmeal_1@3x.61e406ce.jpg";